






































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import { timeout } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import BackofficeSuprimentosStore from './Store/BackofficeSuprimentosStore'
import BackofficeOrcamentoStore from './Store/BackofficeOrcamentoStore'

@Component

export default class ComponentModalVotarStatus extends Vue {
  loadVoltarStatus: boolean = false

  get loadingVoltarStatus() {
    return this.loadVoltarStatus
  }

  set loadingVoltarStatus(value: boolean) {
    this.loadVoltarStatus = value
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get getBackofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  get getBackofficeSuprimentosStore() {
    return getModule(BackofficeSuprimentosStore, this.$store)
  }

  get getBackofficeOrcamentoStore() {
    return getModule(BackofficeOrcamentoStore, this.$store)
  }

  get showModalVoltarStatus() {
    return this.getBackofficeGlobalStore.modal.voltarStatus
  }

  async voltarStatus() {
    this.loadingVoltarStatus = true
    await timeout(500)
    const { agendamentoMedicoId } = this.getBackofficeGlobalStore
    const storeByArea = {
      BackofficeAgendamento: this.getBackofficeAgendamentoStore,
      BackofficeAutorizacao: this.getBackofficeAutorizacaoStore,
      BackofficeSuprimentos: this.getBackofficeSuprimentosStore,
      BackofficeOrcamento: this.getBackofficeOrcamentoStore,
    }
    const store = storeByArea[this.$route.name as keyof typeof storeByArea] || this.getBackofficeAutorizacaoStore
    const response = await store.backofficeVoltaStatus({ solicitacaoId: agendamentoMedicoId })

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.data || 'Status alterado com sucesso!', icon: 'done', color: '#2E7D32' })
      this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao alterar o status', icon: 'warning', color: '#C62828' })
    }

    this.loadingVoltarStatus = false
  }

  async closeModal() {
    await timeout(500)
    this.getBackofficeGlobalStore.clearAgendamentoMedicoId()
    this.getBackofficeGlobalStore.setShowModalVoltarStatus(false)
  }
}
